import {
    AdditionalProductFragment,
    VariantFragment,
} from '@graphql/generated/graphql';
import { useCompanyConfig } from '@lib/config/hooks';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { transform } from '@lib/string-rewriter';
import { useMemo } from 'react';

interface UseShoppableDeeplinkResult {
    href: string | null;
}

export const useShoppableDeeplink = (
    shoppable: AdditionalProductFragment | VariantFragment
): UseShoppableDeeplinkResult => {
    const { platform } = useEmbedContext();
    const { additionalProduct: additionalProductConfig } = useCompanyConfig();

    const originalUrl = shoppable.Url ?? null;

    const resolvedHref = useMemo(() => {
        // Not in app webview, return original URL
        if (originalUrl === null || platform === 'web') {
            return null;
        }

        // No deeplink config, return original URL
        if (!additionalProductConfig.deeplinkRewriteRules) {
            return null;
        }

        // Template-based deeplink resolution
        const rule = additionalProductConfig.deeplinkRewriteRules[platform];
        if (rule) {
            return transform(originalUrl, rule);
        }
        return null;
    }, [platform, originalUrl, additionalProductConfig]);

    return {
        href: resolvedHref ?? originalUrl,
    };
};
